"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearPersistedAuthState = exports.persistSkyAuthState = exports.persistAuthState = exports.loadPersistedAuthState = void 0;
/**
 * Load persisted authentication state from localStorage and cookies
 * This should be called once during app initialization
 */
var loadPersistedAuthState = function () {
    try {
        // Check for Sky Lifestyle credentials first
        var skyUserData = localStorage.getItem("sky_user_data");
        var firebaseToken = localStorage.getItem("firebase_token");
        if (skyUserData && firebaseToken) {
            var user = JSON.parse(skyUserData);
            return {
                user_id: user.id,
                name: user.name,
                surname: user.surname,
                email: user.email,
                access_token: firebaseToken,
                token_type: "Bearer",
                expires_in: 3600, // Default to 1 hour
                last_login: new Date().toISOString(),
                authenticated_via: "Sky Lifestyle",
                firebase_user_id: localStorage.getItem("firebase_user_id") || undefined,
                cell_number: user.cellPhone
                    ? {
                        phone_number: user.cellPhone,
                        country_code: "+264", // Default to Namibia
                        country_abbreviation: "NA", // Default to Namibia
                    }
                    : undefined,
            };
        }
        // Check sessionStorage (used when rememberMe is false)
        var sessionAuthData = sessionStorage.getItem("access_token");
        var sessionUserData = sessionStorage.getItem("user_data");
        if (sessionAuthData && sessionUserData) {
            var userData = JSON.parse(sessionUserData);
            return __assign(__assign({}, userData), { access_token: sessionAuthData });
        }
        // Check for legacy auth data in localStorage
        var legacyAuthData = localStorage.getItem("access_token");
        var legacyUserData = localStorage.getItem("user_data");
        if (legacyAuthData && legacyUserData) {
            var userData = JSON.parse(legacyUserData);
            return __assign(__assign({}, userData), { access_token: legacyAuthData });
        }
    }
    catch (error) {
        console.warn("Failed to load persisted auth state:", error);
    }
    return null;
};
exports.loadPersistedAuthState = loadPersistedAuthState;
/**
 * Persist authentication state to localStorage
 * Should be called after successful authentication
 */
var persistAuthState = function (authData, rememberMe) {
    if (rememberMe === void 0) { rememberMe = false; }
    var storage = rememberMe ? localStorage : sessionStorage;
    // Store auth token
    storage.setItem("access_token", authData.access_token);
    // Store user data
    var userData = {
        user_id: authData.user_id,
        name: authData.name,
        surname: authData.surname,
        email: authData.email,
        token_type: authData.token_type,
        expires_in: authData.expires_in,
        last_login: authData.last_login,
        authenticated_via: authData.authenticated_via,
        cell_number: authData.cell_number,
        firebase_user_id: authData.firebase_user_id,
        facetecDBRef: authData.facetecDBRef,
    };
    storage.setItem("user_data", JSON.stringify(userData));
};
exports.persistAuthState = persistAuthState;
/**
 * Persist Sky Lifestyle authentication data
 * Should be called after successful Sky Lifestyle authentication
 */
var persistSkyAuthState = function (user, firebase, letsTradeToken) {
    // Store Sky Lifestyle specific data
    localStorage.setItem("firebase_token", firebase.idToken);
    localStorage.setItem("firebase_refresh_token", firebase.refreshToken);
    localStorage.setItem("lets_trade_token", letsTradeToken);
    localStorage.setItem("sky_user_data", JSON.stringify(user));
};
exports.persistSkyAuthState = persistSkyAuthState;
/**
 * Clear all persisted authentication data
 */
var clearPersistedAuthState = function () {
    // Clear Sky Lifestyle data
    localStorage.removeItem("firebase_token");
    localStorage.removeItem("firebase_refresh_token");
    localStorage.removeItem("lets_trade_token");
    localStorage.removeItem("sky_user_data");
    // Clear Firebase user ID
    localStorage.removeItem("firebase_user_id");
    // Clear FaceTec data
    localStorage.removeItem("facetecDBRef");
    // Clear legacy data
    localStorage.removeItem("access_token");
    localStorage.removeItem("user_data");
    localStorage.removeItem("refresh_token");
    // Clear session storage
    sessionStorage.removeItem("access_token");
    sessionStorage.removeItem("user_data");
};
exports.clearPersistedAuthState = clearPersistedAuthState;
